import Box from '@zenbusiness/zui/Box';
import superstyled from '@zenbusiness/zui/styles/superstyled';
import Text from '@zenbusiness/zui/Text';

export const CheckInRoot = superstyled({
  name: 'CheckIn',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    backgroundColor: theme.palette.background.grey.light,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(3),
    border: `1px solid ${theme.palette.border.main}`,
    marginBottom: theme.spacing(2)
  })
});

export const ProgressContainer = superstyled({
  name: 'CheckIn',
  slot: 'ProgressContainer',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  })
});

export const CompletedContainer = superstyled({
  name: 'CheckIn',
  slot: 'CompletedContainer',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1)
  })
});

export const CompletedHeader = superstyled({
  name: 'CheckIn',
  slot: 'CompletedHeader',
  tag: Box,
  styles: () => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  })
});

export const Title = superstyled({
  name: 'CheckIn',
  slot: 'Title',
  tag: Text,
  styles: ({ theme }) => ({
    fontSize: theme.typography.body1.fontSize,
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.primary
  })
});

export const Summary = superstyled({
  name: 'CheckIn',
  slot: 'Summary',
  tag: Text,
  styles: ({ theme }) => ({
    fontSize: theme.typography.body2.fontSize,
    color: theme.palette.text.secondary
  })
});

export const FinalMessage = superstyled({
  name: 'CheckIn',
  slot: 'FinalMessage',
  tag: Text,
  styles: ({ theme }) => ({
    fontSize: theme.typography.body2.fontSize,
    color: theme.palette.text.secondary
  })
});

export const ProgressBar = superstyled({
  name: 'CheckIn',
  slot: 'ProgressBar',
  tag: Box,
  styles: ({ theme }) => ({
    width: '100%',
    height: 4,
    borderRadius: 2,
    backgroundColor: theme.palette.background.default,
    position: 'relative',
    overflow: 'hidden',
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      height: '100%',
      width: '100%',
      backgroundColor: theme.palette.primary.main,
      borderRadius: 2,
      animation: 'progress-animation 1.5s ease-in-out infinite'
    },
    '@keyframes progress-animation': {
      '0%': {
        transform: 'translateX(-100%)'
      },
      '50%': {
        transform: 'translateX(-10%)'
      },
      '100%': {
        transform: 'translateX(100%)'
      }
    }
  })
});

export const CheckList = superstyled({
  name: 'CheckIn',
  slot: 'CheckList',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    listStyle: 'none',
    padding: 0,
    margin: 0
  })
});

export const CheckItem = superstyled({
  name: 'CheckIn',
  slot: 'CheckItem',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  })
});

export const CheckIcon = superstyled({
  name: 'CheckIn',
  slot: 'CheckIcon',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.text.disabled,
    '& .MuiSvgIcon-root': {
      fontSize: '0.5rem'
    }
  })
});

export const CompletedIcon = superstyled({
  name: 'CheckIn',
  slot: 'CompletedIcon',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.success.main,
    '& .MuiSvgIcon-root': {
      color: theme.palette.text.blue
    }
  })
});

export const CheckText = superstyled({
  name: 'CheckIn',
  slot: 'CheckText',
  tag: Text,
  styles: ({ theme }) => ({
    fontSize: theme.typography.body2.fontSize,
    color: theme.palette.text.primary
  })
});
